// Lokaler Speicher der App.
// Entscheidung: localStorage statt IndexedDB (Begründung in app/README.md, Abschnitt „Lokaler Speicher“):
//  - synchron: Eine Bewertung steht im Speicher, bevor die nächste Karte erscheint; die SyncEngine (platform/sync/sync.mjs) erwartet genau get/set.
//  - einfach und überall gleich (Browser, installierte Web-App, später Capacitor-WebView); der Prototyp nutzt ihn schon.
//  - Grenze: etwa 5 MB je Adresse, das reicht nach Schätzung für rund 20.000 Bewertungen. Vorher auf IndexedDB umstellen (offener Punkt im Bericht).
// Ohne nutzbaren localStorage (z. B. gesperrt) läuft die App mit einem Speicher im Arbeitsspeicher weiter; dann gilt persistent = false.

export function memoryStore() {
  const m = new Map();
  return {
    persistent: false,
    get: k => (m.has(k) ? m.get(k) : null),
    set: (k, v) => { m.set(k, String(v)); },
    remove: k => { m.delete(k); },
    keys: (prefix = '') => [...m.keys()].filter(k => k.startsWith(prefix)),
  };
}

export function browserStore(ls = globalThis.localStorage) {
  try {
    const probe = 'sentenzo.probe';
    ls.setItem(probe, '1'); ls.removeItem(probe);
  } catch {
    return memoryStore();
  }
  return {
    persistent: true,
    get: k => ls.getItem(k),
    // Schreibfehler (Speicher voll) werden nicht verschluckt: Wer bewertet, muss erfahren, dass nichts gespeichert wurde.
    set: (k, v) => ls.setItem(k, String(v)),
    remove: k => ls.removeItem(k),
    keys: (prefix = '') => { const out = []; for (let i = 0; i < ls.length; i++) { const k = ls.key(i); if (k && k.startsWith(prefix)) out.push(k); } return out; },
  };
}

export const readJson = (store, key, fallback) => { try { const j = store.get(key); return j ? JSON.parse(j) : fallback; } catch { return fallback; } };
export const writeJson = (store, key, value) => store.set(key, JSON.stringify(value));
